import { Member } from '@/features/backlog/types';
import { cn } from '@/components/ui/cn';

/** Mnemonic avatar (initials on the member's color). Empty state is a dashed ring. */
export const MemberAvatar = ({
  member,
  size = 40,
  className,
  ring = true,
}: {
  member?: Member | null;
  size?: number;
  className?: string;
  /** The subtle 1px outline. Turn OFF where avatars overlap (presence stack) so the container's own
   *  solid ring is the only separator — the translucent ring otherwise lets the one beneath peek. */
  ring?: boolean;
}) => {
  if (!member) {
    return (
      <span
        className={cn(
          'inline-flex items-center justify-center rounded-full border border-dashed border-line text-fg-ghost',
          className,
        )}
        style={{ width: size, height: size, fontSize: Math.round(size * 0.5), lineHeight: 1 }}
        aria-label="Unassigned"
      >
        +
      </span>
    );
  }
  const parts = member.name.trim().split(/\s+/).filter(Boolean);
  const initials = (parts.length >= 2 ? parts[0][0] + parts[1][0] : member.name.slice(0, 2)).toUpperCase();
  return (
    <span
      title={member.name}
      className={cn('inline-flex items-center justify-center rounded-full font-semibold text-white', ring && 'ring-1 ring-line', className)}
      style={{ width: size, height: size, background: member.color || '#71717a', fontSize: Math.round(size * 0.36) }}
    >
      {initials}
    </span>
  );
};

export default MemberAvatar;
